var React = require('react');

function W3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"W3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"30.89 78.89 50.41 40.88 69.94 2.88 34.97 1.44 0 0 15.44 39.44 30.89 78.89","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("polygon",{"points":"62.37 0.83 41.88 41.95 61.86 76.5 99.47 1.97 62.37 0.83","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

W3.defaultProps = {"viewBox":"0 0 99.48 78.89"};

module.exports = W3;

W3.default = W3;
